var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-communication-bg-orange';
                    var viewUrl = 'sprite.svg#view-icon-communication-bg-orange';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 46 48',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };